if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.openedBy = opener; // Ensure openedBy is set
        this.showActiveMedia();
      }

      showActiveMedia() {
        if (!this.openedBy) return;

        // Get the media ID from either the clicked element or its parent
        const mediaId = this.openedBy.getAttribute('data-media-id') || 
                       (this.openedBy.closest('[data-media-id]')?.getAttribute('data-media-id'));
        
        if (!mediaId) {
          console.warn('No media ID found for the opened media');
          return;
        }

        // Deactivate all media items
        this.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('active');
        });

        // Activate the selected media
        const activeMedia = this.querySelector(`[data-media-id="${mediaId}"]`);
        if (!activeMedia) {
          console.warn(`Media with ID ${mediaId} not found in modal`);
          return;
        }

        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        if (container && activeMedia.width) {
          container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;
        }

        if (
          activeMedia.nodeName === 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        ) {
          activeMedia.loadContent();
        }
      }
    }
  );
}
